import type { Dispatch, SetStateAction } from "react";
import { IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

interface PassowrdVisibilityButtonProps {
  isPasswordVisible: boolean;
  setIsPasswordVisible: Dispatch<SetStateAction<boolean>>;
}

export const PasswordVisibilityButton = ({
  setIsPasswordVisible,
  isPasswordVisible,
}: PassowrdVisibilityButtonProps) => {
  return (
    <IconButton
      onClick={() => {
        setIsPasswordVisible((prev) => !prev);
      }}
    >
      {isPasswordVisible ? (
        <VisibilityOffOutlinedIcon />
      ) : (
        <VisibilityOutlinedIcon />
      )}
    </IconButton>
  );
};
